import React from "react";
import classes from "./styles/style.module.css";

const CustomTextArea = ({ placeholder, value, handleChange, label, dark }) => {
  return (
    <>
      {label &&
        <label className={`${classes.label} ${dark ? classes.darkLabel : ''}`} htmlFor="customTextArea">
          {label}
        </label>}
      <div className={`${classes.textAreaContainer} ${dark ? classes.darkTextArea : ''}`}>

        <textarea
          name="customTextArea"
          id="customTextArea"
          placeholder={placeholder}
          value={value}
          onChange={(e) => handleChange(e.target.value)}
        ></textarea>
      </div>
    </>

  );
};

export default CustomTextArea;
